import logo from "assets/images/logo-bianco.svg";
import { praticaRiprendiInSeguito } from "common/_redux/pratica/actions";
import { praticaRiprendiSelector } from "common/_redux/pratica/selectors";
import MessageModal from "common/components/message-modal";
import RecuperaPraticaCard from "common/components/recupera-pratica-card";
import RiepilogoTitolariCard from "common/components/riepilogo-titolari";
import { authUserSelector } from "core/auth/_redux/selectors";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import BftStepper from "layout/components/stepper";
import VerticalStepper from "layout/components/vertical-stepper";
import { LayoutUtils } from "layout/helpers/utils";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { layoutStepsSelector } from "../../_redux/selectors";

const Topbar: React.FC = () => {
	const dispatch = useAppDispatch();

	const location = useLocation();

	const steps = useAppSelector(layoutStepsSelector);

	const userInfo = useAppSelector(authUserSelector);
	const reopenPratica = useAppSelector(praticaRiprendiSelector);

	const currentStep = steps?.find(
		(s) => s.route == location.pathname || s?.subSteps?.find((ss) => ss?.route == location.pathname)
	);
	const currentStepIndex =
		steps
			?.filter((s) => !s?.hideOnMenu)
			?.findIndex(
				(s) =>
					s.route == location.pathname || s?.subSteps?.find((ss) => ss?.route == location.pathname)
			) || 0;

	const currentSubstepIndex =
		currentStep?.subSteps?.findIndex((ss) => ss.route == location.pathname) || 0;

	const [isExpanded, setIsExpanded] = useState(false);
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const [showModalRiprendiInSeguito, setShowModalRiprendiInSeguito] = useState<boolean>(false);

	const [showModalRecuperaPratica, setShowModalRecuperaPratica] = useState<boolean>(false);

	const [showModalRiepilogoTitolari, setShowModalRiepilogoTitolari] = useState<boolean>(false);

	const handleCloseModalRiprendi = () => {
		setShowModalRiprendiInSeguito(false);
	};

	const handleCloseModalRecupera = () => {
		setShowModalRecuperaPratica(false);
	};

	const handleCloseModalRiepilogo = () => {
		setShowModalRiepilogoTitolari(false);
	};

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};

	const getMaskedEmail = (email: string | undefined) => {
		if (!email) return;
		return email;
	};

	const getMessageModal = () => {
		return (
			<>
				E' stata inviata un' e-mail per il recupero della pratica all' indirizzo&nbsp;
				<span className="font-weigth-bold m-0">
					{getMaskedEmail(userInfo?.email) || getMaskedEmail(reopenPratica?.userData?.email)}
				</span>
				.<br></br>
				Puoi riprendere il processo subito chiudendo il popup oppure in qualsiasi momento dal link
				che trovi nell' e-mail.
			</>
		);
	};

	const handleRiprendiClick = () => {
		dispatch(praticaRiprendiInSeguito(LayoutUtils.getLastStepBackendRef(steps, location.pathname)))
			.unwrap()
			.then((res) => {
				if (res) {
					setShowModalRiprendiInSeguito(true);
				}
			});
	};

	return (
		<>
			<div className="topbar-container">
				{!isExpanded && (
					<>
						<div className="topbar">
							<div className="logo-container">
								<img alt="Logo" className="img-logo-smaller d-md-block ms-3" src={logo} />
							</div>

							<button
								className={`hamburger-menu-icon ${isMenuOpen ? "open" : ""}`}
								type="button"
								onClick={toggleMenu}
							>
								<span className="bar"></span>
								<span className="bar"></span>
								<span className="bar"></span>
							</button>
							{isMenuOpen && (
								<div className="hamburger-menu">
									<div className="hamburger-menu-wrapper">
										<ul className="hamburger-menu-list">
											{currentStepIndex >= 1 && currentStepIndex <= 7 && (
												<li className="hamburger-menu-item">
													<a onClick={handleRiprendiClick} style={{ color: "white" }}>
														Riprendi in seguito
													</a>
												</li>
											)}
											{currentStepIndex == 0 && currentSubstepIndex == 0 && (
												<li className="hamburger-menu-item">
													<a
														onClick={() => setShowModalRecuperaPratica(true)}
														style={{ color: "white" }}
													>
														Recupera pratica interrotta
													</a>
												</li>
											)}
											{currentStepIndex >= 2 && currentSubstepIndex >= 4 && (
												<li className="hamburger-menu-item-no">
													<a
														onClick={() => setShowModalRiepilogoTitolari(true)}
														style={{ color: "white" }}
													>
														Riepilogo titolari
													</a>
												</li>
											)}
										</ul>
									</div>
								</div>
							)}
						</div>
						{currentStepIndex >= 2 && (
							<div className="topbar-wizard">
								<div className="wizard-container col-10 px-3">
									{currentStepIndex >= 2 && currentStepIndex <= 8 ? (
										<h4 className="text-white my-3">{currentStep?.title}</h4>
									) : (
										<h4 className="text-white my-3">Processo Terminato</h4>
									)}

									<BftStepper
										type="step"
										activeStepIndex={currentStepIndex}
										activeStep={currentStep}
										steps={steps}
										orientation="horizontal"
									/>
								</div>
								<div className="expand-wizard-button col-2">
									<i className="fas fa-chevron-down" onClick={() => setIsExpanded(true)}></i>
								</div>
							</div>
						)}
					</>
				)}
				{isExpanded && (
					<>
						<div className="topbar">
							<div className="topbar-opened col-10">
								<div>
									<img alt="Logo" className="img-logo-smaller d-md-block ms-3" src={logo} />
								</div>
								{/* {currentStepIndex >= 1 && currentStepIndex <= 6 && (
									<div className="d-flex align-items-center px-3">
										<BftButton className="btn-buffetti-secondary mobile">Cambia piano</BftButton>
									</div>
								)} */}
							</div>
							<div className="close-wizard-button col-2">
								<i className="fas fa-xmark" onClick={() => setIsExpanded(false)}></i>
							</div>
						</div>
						<div className="topbar-vertical-wizard">
							<VerticalStepper />
						</div>
					</>
				)}

				<MessageModal
					show={showModalRiprendiInSeguito}
					onClose={handleCloseModalRiprendi}
					message={getMessageModal()}
				/>

				<Modal show={showModalRecuperaPratica} onHide={handleCloseModalRecupera}>
					<Modal.Header closeButton>
						<Modal.Title>Recupera Pratica</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<RecuperaPraticaCard />
					</Modal.Body>
				</Modal>

				<Modal show={showModalRiepilogoTitolari} onHide={handleCloseModalRiepilogo}>
					<Modal.Header closeButton>
						<Modal.Title>Riepilogo titolari effettivi</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<RiepilogoTitolariCard />
					</Modal.Body>
				</Modal>
			</div>
		</>
	);
};

export default Topbar;
